import { useState } from "react";

import { useSetup } from "../../SetupLife.context";
import { IRules } from "../../SetupLife.types";

import { Multistep } from "v2/components";

import { RulesTabReadjustment } from "./Rules.TabReadjustment";
import { RulesTabOperation } from "./Rules.TabOperation";
import { RulesTabInvoicing } from "./Rules.TabInvoicing";
import { RulesTabRegister } from "./Rules.TabRegister";
import { RulesTabCharge } from "./Rules.TabCharge";
import { RulesTabCost } from "./Rules.TabCost";

export function Rules() {
  /** Values needed to change the global state */
  const { setup, updateSetup } = useSetup();

  /** Estado local que possui todos os campos de regra de contrato. */
  const [rules, setRules] = useState<IRules>(setup.rules);

  /** Função responsável por validar e salvar as edições feitas nos campos de regras de contrato. */
  async function handleSave() {
    try {
      //validar...
      updateSetup({ ...setup, rules: rules });
    } catch (error) {
      console.error(error);
    }
  }

  /** Função responsável por editar os campos de regras de contrato. */
  async function handleChange(payload: Partial<IRules>) {
    const updatedRuleFields = { ...rules, ...payload };

    setRules(updatedRuleFields);
  }

  return (
    <Multistep onSubmit={handleSave}>
      <Multistep.Step
        title="Cadastro"
        body={<RulesTabRegister rules={rules} handleChange={handleChange} />}
      />
      <Multistep.Step
        title="Cobrança"
        body={<RulesTabCharge rules={rules} handleChange={handleChange} />}
      />
      <Multistep.Step
        title="Faturamento"
        body={<RulesTabInvoicing rules={rules} handleChange={handleChange} />}
      />
      <Multistep.Step
        title="Operação"
        body={<RulesTabOperation rules={rules} handleChange={handleChange} />}
      />
      <Multistep.Step
        title="Custeio"
        body={<RulesTabCost rules={rules} handleChange={handleChange} />}
      />
      <Multistep.Step
        title="Reajuste do contrato"
        body={<RulesTabReadjustment rules={rules} handleChange={handleChange} />}
      />
    </Multistep>
  );
}
